export enum PointType {
  Empty,
  Plus,
  Minus
}

export class Point {
  point: string;
  date: string;
  exprired: string;
}

export class PointDetail {
  point: string;
  transaction_date: string;
  point_type: number;
  description: string;
}

export class Voucher {
  voucher_id: number;
  category: string;
  title: string;
  information: string;
  term_and_conditions: string;
  point: number;
  label_point: string;
  image: string;
  valid_start_date: string;
  valid_end_date: string;
}

export class RedeemVoucher {
  voucher_merchant_id: number;
  point: number;
  category: string;
}

export class Reward {
  voucher_id: number;
  voucher_catalog_id: string;
  voucher_no: string;
  voucher_title: string;
  image: string;
  information: string;
  terms_and_condition: string;
  valid_start_date: string;
  valid_end_date: string;
  point: number;
  label_point: string;
  voucher_category: string;
  is_redeem: boolean;
}

export class VoucherCategory {
  code: string;
  name: string;
}
